import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import CalendarHeader from './CalendarHeader';
import Calendar from './Calendar';
import MonthFilter from './MonthView/MonthFilter';
import WeekFilter from './WeekView/WeekFilter';
import DayFilter from './DayView/DayFilter';
const ScheduleCalendarView = ({ mediaOptions, source, }) => {
    var _a, _b, _c, _d, _e, _f;
    const [selectedMops, setSelectedMops] = useState([]);
    useEffect(() => {
        setSelectedMops(mediaOptions);
    }, [source, mediaOptions]);
    const handleNext = () => {
        const currentIdx = mediaOptions.findIndex((mop) => mop._id === selectedMops[0]._id);
        setSelectedMops([mediaOptions[currentIdx + 1] || mediaOptions[0]]);
    };
    const handlePrevious = () => {
        const currentIdx = mediaOptions.findIndex((mop) => mop._id === selectedMops[0]._id);
        setSelectedMops([
            mediaOptions[currentIdx - 1] || mediaOptions[mediaOptions.length - 1],
        ]);
    };
    let schedule = [];
    selectedMops.forEach((mop) => {
        if (mop === null || mop === void 0 ? void 0 : mop.schedule) {
            const restructuredSchedules = mop.schedule.map((sch) => {
                var _a;
                return Object.assign(Object.assign({}, sch), { name: (mop === null || mop === void 0 ? void 0 : mop.name) + ((mop === null || mop === void 0 ? void 0 : mop.media.name) ? ` - ${(_a = mop === null || mop === void 0 ? void 0 : mop.media) === null || _a === void 0 ? void 0 : _a.name}` : ''), toolName: mop.toolName, _mediaOption: mop._id });
            });
            schedule =
                schedule.length > 0
                    ? [...schedule, ...restructuredSchedules]
                    : [...restructuredSchedules];
        }
    });
    const [month, setMonth] = useState(((_a = schedule[0]) === null || _a === void 0 ? void 0 : _a.date) ? new Date((_b = schedule[0]) === null || _b === void 0 ? void 0 : _b.date) : new Date());
    const [week, setWeek] = useState(((_c = schedule[0]) === null || _c === void 0 ? void 0 : _c.date) ? new Date((_d = schedule[0]) === null || _d === void 0 ? void 0 : _d.date) : new Date());
    const [day, setDay] = useState(((_e = schedule[0]) === null || _e === void 0 ? void 0 : _e.date) ? new Date((_f = schedule[0]) === null || _f === void 0 ? void 0 : _f.date) : new Date());
    const [value, setValue] = useState(2);
    return (_jsxs(Box, Object.assign({ sx: {
            position: 'relative',
            height: '85%',
            p: 4,
            borderRadius: 2,
            background: '#fff',
        } }, { children: [_jsxs(Box, Object.assign({ sx: { height: 114 } }, { children: [_jsx(CalendarHeader, { selectedMops: selectedMops, onNext: handleNext, onPrevious: handlePrevious, source: source, disableNavigation: mediaOptions.length < 2 }), _jsx(Divider, { sx: { borderColor: '#DCDFE4', margin: '12px 0px' } }), _jsxs(Box, Object.assign({ display: "flex", flexDirection: "row", justifyContent: "space-between" }, { children: [_jsxs(Tabs, Object.assign({ onChange: (e, value) => setValue(value), value: value, "aria-label": "Tabs where each tab needs to be selected manually", TabIndicatorProps: {
                                    style: { display: 'none' },
                                }, sx: {
                                    '&.MuiTabs-root': {
                                        backgroundColor: '#DCDFE4',
                                        borderRadius: '4px',
                                        minHeight: '10px',
                                        maxHeight: '35px',
                                        zIndex: 0,
                                    },
                                } }, { children: [_jsx(Tab, { label: "Day", sx: {
                                            fontSize: '16px',
                                            '&.MuiTab-root': {
                                                paddingX: '10px',
                                                minWidth: '10px',
                                                minHeight: '5px',
                                                maxHeight: '35px',
                                            },
                                            '&.Mui-selected': {
                                                color: 'white',
                                                backgroundColor: '#6E60C4',
                                                borderRadius: '4px',
                                            },
                                        } }), _jsx(Tab, { label: "Week", sx: {
                                            fontSize: '16px',
                                            '&.MuiTab-root': {
                                                paddingX: '10px',
                                                minWidth: '10px',
                                                minHeight: '5px',
                                                maxHeight: '35px',
                                            },
                                            '&.Mui-selected': {
                                                color: 'white',
                                                backgroundColor: '#6E60C4',
                                                borderRadius: '4px',
                                            },
                                        } }), _jsx(Tab, { label: "Month", sx: {
                                            fontSize: '16px',
                                            '&.MuiTab-root': {
                                                paddingX: '10px',
                                                minWidth: '10px',
                                                minHeight: '5px',
                                                maxHeight: '35px',
                                            },
                                            '&.Mui-selected': {
                                                color: 'white',
                                                backgroundColor: '#6E60C4',
                                                borderRadius: '4px',
                                            },
                                        } })] })), value === 0 && _jsx(DayFilter, { day: day, setDay: setDay }), value === 1 && _jsx(WeekFilter, { week: week, setWeek: setWeek }), value === 2 && _jsx(MonthFilter, { month: month, setMonth: setMonth })] }))] })), _jsx(Box, Object.assign({ sx: {
                    overflow: 'scroll',
                } }, { children: _jsx(Calendar, { schedule: schedule, isEditable: false, source: source, day: day, week: week, month: month, value: value }) }))] })));
};
export default ScheduleCalendarView;
